exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.order-review[data-v-fc151300]{margin-top:40px;margin-bottom:50px\n}\n.order-review h1[data-v-fc151300]{margin-bottom:20px\n}\n.order-review span[data-v-fc151300]{font-weight:600\n}\n.order-review p[data-v-fc151300]{line-height:20px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fc151300","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/payments/PaymentSuccess.vue
// module id = 190
// module chunks = 0